import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { uuid } from "@/interfaces";
import { ClientsDetailState } from "./clients-detail.entity";
import { getClientById, getPropertiesByClientId } from "./clients-detail.api";

const initialState: ClientsDetailState = {
  data: null,
  loading: true,
  error: null,
  properties: [],
  propertiesLoading: false,
};

export const fetchClientDetail = createAsyncThunk("clients-detail/fetch", async (id: uuid) => {
  return await getClientById(id);
});

export const fetchClientProperties = createAsyncThunk("clients-detail-properties/fetch", async (id: uuid) => {
  return await getPropertiesByClientId(id);
});

const clientsDetailSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (b) =>
    b
      .addCase(fetchClientDetail.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchClientDetail.fulfilled, (s, a) => {
        s.loading = false;
        s.data = a.payload;
      })
      .addCase(fetchClientDetail.rejected, (s, a) => {
        s.loading = false;
        s.data = null;
        s.error = a.error.message ?? "Failed to load client";
      })
      .addCase(fetchClientProperties.pending, (s) => {
        s.propertiesLoading = true;
      })
      .addCase(fetchClientProperties.fulfilled, (s, a) => {
        s.propertiesLoading = false;
        s.properties = a.payload;
      })
      .addCase(fetchClientProperties.rejected, (s, a) => {
        s.propertiesLoading = false;
        s.properties = [];
        s.error = a.error.message ?? "Failed to load client";
      }),
});

export default clientsDetailSlice.reducer;
